<label for="search-by-text" class="d-flex align-items-center justify-content-start h-100 mt-3 mt-md-0">
    <span class="pr-1">Buscar</span>
    <div class="d-flex flex-row-reverse">
        <input #searchInput id="search-by-text" type="text"
            class="form-control form-control-sm d-inline-block width-200" (keyup)="searchByText($event)" />
        <button *ngIf="searchInput.value" type="button" class="clear-btn" (click)="clearInput(searchInput)"
            container="body" data-toggle="tooltip" placement="top" ngbTooltip="Limpiar búsqueda"
            aria-label="Limpiar búsqueda">
            &times;
        </button>
    </div>
</label>